import { 
  BookOutlined,
  PushpinOutlined,
  FileProtectOutlined,
  AuditOutlined,
  QuestionCircleOutlined,
  CustomerServiceOutlined,
  DollarOutlined,
  MessageOutlined,
  CalendarOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

import mano from './icons/mano.js'
import reloj from './icons/reloj.js'
import calendario from './icons/calendario.js'
import agregarCalendario from './icons/agregarCalendario.js'
import pencilIcono from './icons/pencilIcono.js'
import settingsIcono from './icons/settingsIcono.js'
import timeArena from './icons/timeArena.js'
import filesIcono from './icons/filesIcono.js'



import pizarron from './icons/pizarron.js'
import departamentos from './icons/departamentos.js'
import graduacionCap from './icons/graduacionCap.js'
import checkIcono from './icons/check.js'
import book from './icons/book.js'
import encuestasIcono from './icons/encuestasIcono.js'
import materiaIcono from './icons/materiaIcono.js'
import reloadIcono from './icons/reloadIcono.js'
import checkUser from './icons/checkUser.js'
import familiaIcono from './icons/familia.js'
import chatIcon from './icons/chatIcon.js'
import difusionIcono from './icons/difusionIcono.js'




import chartbar from './icons/chartbar.js'
import lapiz from './icons/lapiz.js'
import grados from './icons/grados.js'
import ciclo from './icons/ciclo.js'

import maestro from './icons/maestro.js'
import userextra from './icons/userextra.js'


const admins = [{
  key: 'Familiar',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'sidenav.padres.padres',
  icon: BookOutlined,
  breadcrumb: true,
  submenu: [
    {
      key: 'Familia',
      path: `${APP_PREFIX_PATH}/familia`,
      title: 'sidenav.padres.familia',
      icon: familiaIcono, 
      breadcrumb: false,
      submenu: [
      ]
    },
    {
        key: 'Asignaturas',
        path: `${APP_PREFIX_PATH}/cursos/list`,
        title: 'sidenav.admin.asignaturas',
        icon: materiaIcono, 
        breadcrumb: false,
        submenu: [
        ]
    },
    {
        key: 'Horario',
        path: `${APP_PREFIX_PATH}/horario`,
        title: 'sidenav.horario',
        icon: CalendarOutlined, 
        breadcrumb: false,
        submenu: [
        ]
    },
    {
        key: 'Calificaciones',
        path: `${APP_PREFIX_PATH}/calificaciones`,
        title: 'sidenav.alumnos.calificaciones',
        icon: CheckCircleOutlined, 
        breadcrumb: false,
        submenu: [
          {
            key: 'Mis Pines',
            path: `${APP_PREFIX_PATH}/calificaciones/pines`,
            title: 'sidenav.alumnos.pines',
            icon: PushpinOutlined, 
            breadcrumb: true,
            submenu: [
            ]
          },
          {
            key: 'Boleta',
            path: `${APP_PREFIX_PATH}/calificaciones/boleta`,
            title: 'sidenav.alumnos.boleta',
            icon: FileProtectOutlined, 
            breadcrumb: true,
            submenu: [
            ]
          },
          {
            key: 'Kardex',
            path: `${APP_PREFIX_PATH}/calificaciones/kardex`,
            title: 'sidenav.alumnos.kardex',
            icon: AuditOutlined, 
            breadcrumb: true,
            submenu: [
            ]
          },
        ]
    },
    {
      key: 'Inscripción',
      path: `${APP_PREFIX_PATH}/inscripcion`,
      title: 'sidenav.alumnos.inscripcion',
      icon: reloadIcono, 
      breadcrumb: false,
      submenu: [
      ]
    },
    {
      key: 'Estado de cuenta',
      path: `${APP_PREFIX_PATH}/estado-cuenta`,
      title: 'sidenav.alumnos.estado-cuenta',
      icon: DollarOutlined, 
      breadcrumb: false,
      submenu: [
      ]
    },
    {
        key: 'Ayuda',
        path: `${APP_PREFIX_PATH}/pages`,
        title: 'sidenav.ayuda.ayuda',
        icon: QuestionCircleOutlined,
        breadcrumb: true,
        submenu:[{
          key: 'ayuda-preguntas',
          path: `${APP_PREFIX_PATH}/pages/preguntas`,
          title: 'sidenav.ayuda.faq',
          icon: QuestionCircleOutlined,
          breadcrumb: true,
          submenu:[]
        },
        {
          key: 'ayuda-soporte',
          path: `${APP_PREFIX_PATH}/pages/soporte`,
          title: 'sidenav.ayuda.soporte',
          icon: CustomerServiceOutlined,
          breadcrumb: true,
          submenu:[]
        },
        {
            key: 'ayuda-manuales',
            path: `${APP_PREFIX_PATH}/pages/manuales`,
            title: 'sidenav.ayuda.manual',
            icon: book,
            breadcrumb: true,
            submenu:[]
        },
    ]
    }


  ]
}]




   

const Comunicacion = [{
    key: 'comunicacion',
    path: `${APP_PREFIX_PATH}/`,
    title: 'sidenav.comunicacion',
    icon: QuestionCircleOutlined,
    breadcrumb: true,
    submenu:[
      // {
      // key: 'avisos',
      // path: `${APP_PREFIX_PATH}/avisos`,
      // title: 'sidenav.avisos',
      // icon: InfoCircleOutlined,
      // breadcrumb: true,
      // submenu:[]
      // },
    // {
    //     key: 'mensajes',
    //     path: `${APP_PREFIX_PATH}/mensajes`,
    //     title: 'sidenav.mensajes',
    //     icon: chatIcon,
    //     breadcrumb: true,
    //     submenu:[]
    // },
    {
      key: 'archivos',
      path: `${APP_PREFIX_PATH}/archivos`,
      title: 'sidenav.archivos',
      icon: filesIcono,
      breadcrumb: true,
      submenu:[]
    },
    // {
    //     key: 'encuestas',
    //     path: `${APP_PREFIX_PATH}/encuestas`,
    //     title: 'sidenav.encuestas',
    //     icon: encuestasIcono,
    //     breadcrumb: true,
    //     submenu:[]
    // },
    {
      key: 'grupos-difusion-',
      path: `${APP_PREFIX_PATH}/difusion`,
      title: 'sidenav.gruposdifusion',
      icon: difusionIcono,
      breadcrumb: true,
      submenu:[]
    }
]
}]


const navigationConfig = [...admins,...Comunicacion]

export default navigationConfig;
